
import csstype.ClassName
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLElement
import org.w3c.dom.url.URL
import react.FC
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.useEffect

val GraniteColors = FC<stoneSampleProp> {
    val params = URL(document.URL).searchParams
    val stype = params.get("stype") ?: "granite"
    val stone = AsPacStoneType.getStoneName(stype)

    HeaderComponent()
    Menu{
        stoneType = stone
    }

    div {
        className = ClassName("content")
        h1 {
            +"${stype.replaceFirstChar { it.uppercase() }} Samples"
        }
    }
    ShowSampleImages{
        highIterator = 7
        stoneType = stone
    }

    /* Create sticky header */
    useEffect{
        window.onscroll = {
            val navbar = document.getElementById("navbar")
            var sticky = (navbar as HTMLElement).offsetTop

            if (window.pageYOffset > sticky)
                navbar.classList.add("sticky")
            else
                navbar.classList.remove("sticky")
        }
    }
}